import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2
            className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            按分类浏览韩国漫画
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            从恋爱到悬疑，从奇幻到搞笑，找到你最喜欢的<strong>韩国漫画</strong>类型
          </p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
          {categories.filter(c => c.slug !== "all").map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2.5 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer no-underline group"
            >
              <span className="w-11 h-11 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap group-hover:text-primary-700 transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}